function updateHeroButtonText(newPlayerEl) {
  const heroButtonText = document.querySelector(
    ".js-lesson-hero-button span"
  ) as HTMLButtonElement;
  if (!heroButtonText) return;

  const nextLessonNumber = newPlayerEl.dataset.lessonNumber;
  heroButtonText.textContent = `Continue to lesson ${nextLessonNumber}`;
}

export { updateHeroButtonText };
